/*
    Implementation to use redux form with input field.

    this is reusable field for the text, email, password, number
*/
import React from 'react';

import {
   Input,
} from 'reactstrap';

const UpwardReduxInput = ({ input, meta: { touched, error, warning }, className, ...custom }) => {
   return (
      <Input {...(touched ? { valid: !error } : {})} {...input} {...custom} className={(touched && error ? ' is-invalid ' : '') + (className ? ` ${ className }` : '')} />
   );
};

export default UpwardReduxInput;
